import { nanoid } from "nanoid";
export const asTripId = (s) => s;
export const asCategoryId = (s) => s;
export const asItemId = (s) => s;
export const asTodoId = (s) => s;
export const asTemplateId = (s) => s;
export const asUserId = (s) => s;
export const asManagedProfileId = (s) => s;
export const asNoteId = (s) => s;
export const asListId = (s) => s;
export const newId = () => nanoid();
//# sourceMappingURL=ids.js.map